import Image from "next/image";
import styles from "./InspiringInnovation.module.css";

interface InspiringInnovationProps {
  Data: {
    title_image: {
      title: string;
      image: {
        url: string;
      };
    };
    count_cards: Array<{
      id: number;
      title: string;
      description: string;
    }>;
  };
}

const InspiringInnovation: React.FC<InspiringInnovationProps> = ({ Data }) => {
  const leftCards = Data.count_cards.slice(0, 3);
  const rightCards = Data.count_cards.slice(3);

  return (
    <div className={styles.InspiringInnovation}>
      <div className={styles.container}>
        <div className={styles.centerHeadingMobile}>
          <h1>{Data?.title_image?.title}</h1>
        </div>
        <div className={styles.overlay}>
          <Image
            src={Data?.title_image?.image.url}
            alt="Background Image"
            title="Background Image"
            fill
            style={{
              objectFit: "cover",
            }}
            className={styles.backgroundImage}
          />
        </div>
        <div className={styles.contentWrapper}>
          {/* Left side content */}
          <div className={styles.leftContent}>
            {leftCards.map((card) => (
              <div key={card?.id} className={styles.stat}>
                <h2>{card?.title}</h2>
                <p>{card?.description}</p>
              </div>
            ))}
          </div>

          {/* Center Heading */}
          <div className={styles.centerHeading}>
            <h1>{Data?.title_image?.title}</h1>
          </div>

          {/* Right side content */}
          <div className={styles.rightContent}>
            {rightCards.map((card) => (
              <div key={card?.id} className={styles.statRight}>
                <h2>{card?.title}</h2>
                <p>{card?.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InspiringInnovation;
